var _rect, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 23,
    rx: 11,
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_1517)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_514_1517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H20V21H2V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_514_1517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51598 5.9209C9.21298 5.4719 9.85798 5.1269 10.942 5.1269C12.559 5.1269 12.925 5.3689 13.754 6.0309C14.504 6.6299 14.961 7.4069 14.961 8.5109C14.961 9.1879 14.597 9.9189 14.259 10.3819C14.062 10.6629 13.8 10.9419 13.239 11.3799L12.627 11.8499C12.327 12.0839 12.029 12.4379 11.93 12.7499C11.868 12.9479 11.872 13.3729 11.868 13.7889H10.008C10.039 12.9089 10.042 12.1839 10.177 11.8479C10.312 11.5119 10.66 11.1249 11.221 10.6879L11.768 10.2419C11.955 10.1019 12.243 9.8879 12.357 9.7209C12.565 9.4349 12.746 9.0199 12.746 8.6759C12.746 8.2799 12.768 7.9999 12.537 7.6739C12.267 7.2959 12.021 6.8799 10.859 6.8599C9.95398 6.8439 9.56798 7.3069 9.31698 7.7069C9.06498 8.1089 8.97898 8.5649 8.97898 8.9969H7.00098C7.06398 7.5129 7.54198 6.5409 8.51598 5.9209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0127 15.016H11.9917V17H10.0127V15.016Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_1517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 15,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7a3e4a22435c6b0fd621d29832e882a2.svg";
export { ForwardRef as ReactComponent };